import React from 'react';
import { connect } from 'react-redux';
import '../../App.css';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import OtherViewed from './otherViewed';
import { withRouter } from 'react-router';
import { catchJSException } from './../../service/logService';
import { updateSCTags } from './../../service/dtmTag';
import { Utils } from '../../util/utils';

class ProductDetailsInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      desStatus: true,
      overviewStatus: true,
      featureStatus: false,
      addInfoStatus: false,
      specsStatus: false,
      flag: false,
      indexOfTab: 0,
      productsDetailsState: [],
      showAns: false,
    };
    this.handleTabSwitch = this.handleTabSwitch.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleTabSwitch(e, index) {
    try {
      if (index === 0) {
        updateSCTags('description');
        this.setState({
          desStatus: true,
          overviewStatus: false,
          featureStatus: false,
          addInfoStatus: false,
          specsStatus: false,
        });
      } else if (index === 1) {
        updateSCTags('overview');
        this.setState({
          overviewStatus: true,
          desStatus: false,
          featureStatus: false,
          addInfoStatus: false,
          specsStatus: false,
        });
      } else if (index === 2) {
        updateSCTags('features');
        this.setState({
          featureStatus: true,
          desStatus: false,
          overviewStatus: false,
          addInfoStatus: false,
          specsStatus: false,
        });
      } else if (index === 3) {
        updateSCTags('spec');
        this.setState({
          specsStatus: true,
          desStatus: false,
          featureStatus: false,
          overviewStatus: false,
          addInfoStatus: false,
        });
      } else {
        updateSCTags('additional information');
        this.setState({
          addInfoStatus: true,
          desStatus: false,
          featureStatus: false,
          overviewStatus: false,
          specsStatus: false,
        });
      }
    } catch (ex) {
      catchJSException('productDetailsInfo', this.props.appState.visitId, 'handleTabSwitch', ex);
    }
  }

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside(event) {
    try {
      if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({
          optionDisplay: false,
        });
      }
    } catch (ex) {
      catchJSException('productDetailsInfo', this.props.appState.visitId, 'handleClickOutside', ex);
    }
  }
  tabClick = (index, e) => {
    let header = this.props.productDetailsValue.tabContentList[index].title;
    updateSCTags(header);
    this.setState({ indexOfTab: index });
    e.target.parentElement.parentElement.lastChild.focus();
  };
  tabKeyEvent = (e) => {
    try {
      let keyCode = e.keyCode;
      // if (keyCode === 38 || keyCode === 39) {
      if (keyCode === 39) {
        if (e.target && e.target.nextElementSibling) {
          e.target.nextElementSibling.focus();
        }
        // } else if (keyCode === 37 || keyCode === 40) {
      } else if (keyCode === 37) {
        if (e.target && e.target.previousElementSibling) {
          e.target.previousElementSibling.focus();
        }
      } else if (keyCode === 35) {
        if (e.target && e.target.parentElement) {
          e.target.parentElement.lastChild.focus();
        }
      } else if (keyCode === 36) {
        if (e.target && e.target.parentElement) {
          e.target.parentElement.firstChild.focus();
        }
      }
    } catch (ex) {
      catchJSException('pdp', '', 'tabKeyEvent', ex);
    }
  };

  showAns = (Index) => {
    try {
      let id = document.getElementById(Index);
      if (id.className === 'm_accordion-summary m_single') {
        id.className = 'm_accordion-summary m_single open';
      } else if (id.className === 'm_accordion-summary m_single open') {
        id.className = 'm_accordion-summary m_single';
      }
    } catch (ex) {
      catchJSException('pdp', '', 'showAns', ex);
    }
  };
  htmlParserTransform = (node, index) => {
    if (
      node.type === 'tag' &&
      node.name === 'li' &&
      (node.attribs.class === 'm_accordion-summary m_single border-top-none' || node.attribs.class === 'm_accordion-summary m_single')
    ) {
      node.attribs.class = '';
      return (
        <div
          id={index}
          class="m_accordion-summary m_single"
          style={{ borderTop: '.0625rem solid #959595', height: '65px' }}
          onClick={() => this.showAns(index)}
        >
          <span pointerEvents="none">{convertNodeToElement(node, index, this.htmlParserTransform)}</span>
        </div>
      );
    }
    if (node.type === 'tag' && node.name === 'img') {
      let path = node.attribs.src;
      // node.attribs.src = Utils.getDomainUrl() + path;
      node.attribs.src = Utils.getImagePath(path);
      return convertNodeToElement(node, index, this.htmlParserTransform);
    }
    if (node.type === 'tag' && node.name === 'a') {
      let path = node.attribs.href;
      if (path.substring(0, 24) === '/home/accessories/media/') {
        node.attribs.href = Utils.getDomainUrl() + path;
      } else {
        node.attribs.href = Utils.getContentPath(path);
      }
      return convertNodeToElement(node, index, this.htmlParserTransform);
    }
  };
  render() {
    let description = [];
    let overview = [];
    let features = [];
    let additionalInfo = [];
    let specs = [];
    let tabContent = [];
    let tabContentDesc = [];
    let otherViewed;

    // const options = {
    //     decodeEntities: true,
    //     transform
    // };

    // function transform(node, index) {
    //     if (node.type === 'tag' && node.name === 'img') {
    //         let path = node.attribs.src;
    //         node.attribs.src = Utils.getDomainUrl() + path;
    //         return convertNodeToElement(node, index, transform);
    //     }
    //     if (node.type === 'tag' && node.name === 'a') {
    //         let path = node.attribs.href;
    //         if(path.substring(0,24)==="/home/accessories/media/"){
    //             node.attribs.href = Utils.getDomainUrl() + path;
    //         }
    //         return convertNodeToElement(node, index, transform);
    //     }
    // }

    if (this.props.productDetailsValue) {
      description = this.props.productDetailsValue.description;
      overview = this.props.productDetailsValue.overview;
      features = this.props.productDetailsValue.features;
      specs = this.props.productDetailsValue.specs;
      additionalInfo = this.props.productDetailsValue.additionalInformation;

      if (description !== null && this.state.flag === false) {
        this.setState({ description: true });
        this.setState({ flag: true });
      } else if (overview !== null && this.state.flag === false) {
        this.setState({ overviewStatus: true });
        this.setState({ flag: true });
      } else if (features !== null && this.state.flag === false) {
        this.setState({ featureStatus: true });
        this.setState({ flag: true });
      } else if (specs !== null && this.state.flag === false) {
        this.setState({ specsStatus: true });
        this.setState({ flag: true });
      } else if (additionalInfo !== null && this.state.flag === false) {
        this.setState({ addInfoStatus: true });
        this.setState({ flag: true });
      }
    }

    if (this.props.productValue && this.props.productValue.otherValue) {
      otherViewed = (
        <OtherViewed
          appState={this.props.appState}
          otherVieweditems={this.props.productValue.otherValue}
          props={this.props}
          categoriesState={this.props.categoriesState}
        ></OtherViewed>
      );
    }
    const { indexOfTab } = this.state;
    // let description1 = description === null ? "" : <li className={this.state.desStatus ? "tabs_tab active" : "tabs_tab"} data-tab="Description" aria-selected={this.state.desStatus} tabIndex="-1" role="tab" onClick={(e) => this.handleTabSwitch(e, 0)}>Description </li>
    // let overview1 = overview === null ? "" : <li className={this.state.overviewStatus ? "tabs_tab active" : "tabs_tab"} data-tab="Overview" aria-selected={this.state.overviewStatus} tabIndex="-1" role="tab" onClick={(e) => this.handleTabSwitch(e, 1)}>Overview </li>
    // let features1 = features === null ? "" : <li className={this.state.featureStatus ? "tabs_tab active" : "tabs_tab"} data-tab="Features" aria-selected={this.state.featureStatus} tabIndex="-1" role="tab" onClick={(e) => this.handleTabSwitch(e, 2)}>Features </li>
    // let specs1 = specs === null ? "" : <li className={this.state.specsStatus ? "tabs_tab active" : "tabs_tab"} data-tab="specs" aria-selected={this.state.specsStatus} tabIndex="-1" role="tab" onClick={(e) => this.handleTabSwitch(e, 3)}>Specs </li>
    // let additionalInfo1 = additionalInfo === null ? "" : <li className={this.state.addInfoStatus ? "tabs_tab active" : "tabs_tab"} data-tab="Additional Information" aria-selected={this.state.addInfoStatus} tabIndex="-1" role="tab" onClick={(e) => this.handleTabSwitch(e, 4)} >Additional Information </li>
    if (this.props.productDetailsValue) {
      this.props.productDetailsValue.tabContentList.map((tabContentExp, index) => {
        return tabContent.push(
          // <button role="tab">
          // <li
          <button
            role="tab"
            className={indexOfTab === this.props.productDetailsValue.tabContentList.indexOf(tabContentExp) ? 'tabs_tab active' : 'tabs_tab'}
            data-tab=""
            style={{ fontFamily: 'inherit', background: 'inherit' }}
            aria-selected={indexOfTab === this.props.productDetailsValue.tabContentList.indexOf(tabContentExp) ? 'true' : 'false'}
            tabindex={indexOfTab === this.props.productDetailsValue.tabContentList.indexOf(tabContentExp) ? '0' : '-1'}
            onKeyDown={(e) => this.tabKeyEvent(e)} // for key navigation
            // onFocus={() => this.tabClick(this.props.productDetailsValue.tabContentList.indexOf(tabContentExp))}
            onClick={(e) => this.tabClick(this.props.productDetailsValue.tabContentList.indexOf(tabContentExp), e)}
          >
            {ReactHtmlParser(tabContentExp.title)}

            {/* </li> */}
          </button>,
        );
      });
    }

    if (this.props.productDetailsValue) {
      tabContentDesc.push(
        ReactHtmlParser(this.props.productDetailsValue.tabContentList[indexOfTab].description, { transform: this.htmlParserTransform }),
      );
    }

    return (
      <React.Fragment>
        <>
          <div class="m_tabholder">
            <div>
              <div role="tablist" className="w_tabs products-description_tab m_product-details" data-tabs="">
                {/* <ul className="w_tabs products-description_tab m_product-details" data-tabs="" tabIndex="-1" role="tablist"> */}
                {/* <li className="tabs_tab active" data-tab="" aria-selected="true"
                                tabindex = "-1" role="tab">{tabContent} </li> */}
                {tabContent}

                {/* {description1}
                        {overview1}
                        {features1}
                        {specs1}
                        {additionalInfo1} */}
                {/* <li className="tabs_spacer"></li> */}
                {/* </ul> */}
              </div>

              <div className="padding-left-zero" role="tabpanel" tabindex="0">
                {/* <div className="clear" tabIndex="0"> */}
                <div className="clear">{tabContentDesc}</div>
              </div>
            </div>
          </div>
        </>
        {/* <div className="padding-left-zero">
                        <div className="clear">
                            <div className={this.state.desStatus ? "active" : ""} aria-selected={this.state.desStatus} data-tabs-content="Description" aria-hidden="false">
                                {ReactHtmlParser(description, options)}
                            </div>

                            <div className={this.state.overviewStatus ? "active" : ""} aria-selected={this.state.overviewStatus} data-tabs-content="Overview" aria-hidden="false">
                                {ReactHtmlParser(overview, options)}
                            </div>



                            <div className={this.state.featureStatus ? "active" : ""} aria-selected={this.state.featureStatus} data-tabs-content="Features" aria-hidden="false">
                                <ul className="w_list-control m_condensed data-list-control">
                                    {ReactHtmlParser(features, options)}
                                </ul>
                            </div>



                            <div className={this.state.specsStatus ? "active" : ""} aria-selected={this.state.specsStatus} data-tabs-content="Specs" aria-hidden="false">
                                <ul className="apex-book products-overview_lists">
                                    {ReactHtmlParser(specs, options)}
                                </ul>
                            </div>



                            <div className={this.state.addInfoStatus ? "active" : ""} aria-selected={this.state.addInfoStatus} data-tabs-content="Additional Info" aria-hidden="false">
                                <ul className="apex-book products-overview_lists">
                                    {ReactHtmlParser(additionalInfo, options)}
                                </ul>
                            </div>
                        </div> 
                     </div>  */}

        {otherViewed}
        {/* <div className="margin-bottom-large clear">&nbsp;</div> */}
        {/* <div className="margin-bottom-large clear">&nbsp;</div> */}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    appState: state.appVTP,
    cartProduct: state.cartProductDataVTP,
    // otherState:state.prod
  };
};
export default withRouter(connect(mapStateToProps)(ProductDetailsInfo));
// export default connect(

// )(ProductDetailsInfo)
